<template>
  <div class="hero-container" ref="Hero" id="Hero">
    <!-- <div class="hero_logo-container">
      <img :src="mhllogoImage" alt="">
    </div> -->
    <div class="video">
     <div id="videoy"></div>
    </div>
    <div class="hero_logo-container">
      <p class="button-ritual">
        <a href="https://millerhighlife.com.mx/goldenritual" @click="onEvib2cOutboundlinkPush('Golden Ritual', 'Interaccion')">VISITAR GOLDEN RITUAL</a>
      </p>
    </div>
  </div>
</template>

<script>
import mhllogo from "@/assets/miller-high-life-logo.png";
//Implementar tag 
import tagFunctions from '../utils/tagFunctions';
//Libreria para implementacion de tags
import YouTubePlayer from 'youtube-player';
//Variables para Implementar tag 
let timer, percent = 0, quartileTime, duration

import { mapActions, mapGetters } from "vuex";

export default {
  name: "Hero",
  components: {
    mhllogoImage: mhllogo,
  },
  computed: {
    ...mapGetters(
      ['']
    )
  },
  data() {
    return {
      mhllogoImage: mhllogo,
      videoy: null,
    };
  },
  methods: {
    ...mapActions({
    }),
    /* Funciones de los tag*/
    record(event) {
      let currentTime = Math.round(event.target.getCurrentTime());
      percent = getPercent(event);
      if (currentTime == quartileTime) {
          tagFunctions.evVideoPush(
          event.target.getVideoData().title,
          "Reach",
          "25",
          duration,
          "Hero"
          );
      }
      if (currentTime == 2 * quartileTime) {
        tagFunctions.evVideoPush(
        event.target.getVideoData().title,
        "Reach",
        "50",
        duration,
        "Hero"
        );
      }
      if (currentTime == 3 * quartileTime) {
        tagFunctions.evVideoPush(
        event.target.getVideoData().title,
        "Reach",
        "75",
        duration,
        "Hero"
        );
      }
      if (currentTime == Math.round(event.target.getDuration() * 0.99)) {
        tagFunctions.evVideoPush(
        event.target.getVideoData().title,
        "Reach",
        "100",
        duration,
        "Hero"
        );
      }
      function getPercent(event) {
        return Math.round(
        (event.target.getCurrentTime() / event.target.getDuration()) * 100);
      }
    },
    /* Funciones de los tag*/
    onPlayerStateChange(event) {
      duration = event.target.getDuration();
      quartileTime = Math.round(event.target.getDuration() / 4);
      const getQuartile = () => {
        if (percent <= 25) return 25;
        else if (percent > 25 && percent <= 50) return 50;
        else if (percent > 50 && percent <= 75) return 75;
        else return 100;
      };
      if (event.data == window.YT.PlayerState.PLAYING) {
        tagFunctions.evVideoPush(event.target.getVideoData().title, "Play", getQuartile(), duration, "Hero")
        timer = setInterval(() => {
        this.record(event);
        }, 1000);
      } else {
        clearInterval(timer);
      }
      if (event.data == window.YT.PlayerState.ENDED) {
        tagFunctions.evVideoPush(event.target.getVideoData().title, "Complete", getQuartile(), duration, "Hero")
      }
      if (event.data == window.YT.PlayerState.PAUSED) {
        tagFunctions.evVideoPush(event.target.getVideoData().title, "Pause", getQuartile(), duration, "Hero")  
      }
    },
    //Implementar tag ib2c Outboundlink Events
    onEvib2cOutboundlinkPush(name, tipo) {
      tagFunctions.evib2cOutboundlinkPush(name, tipo)
    },
  },
  mounted() {
    this.videoy = YouTubePlayer('videoy', {videoId: 'DTprgaLJjAg', width: '100%', height:'85%'})
    this.videoy.on('stateChange', this.onPlayerStateChange)
  },
};
</script>

<style scoped lang="scss">
@import "~@/styles/hero.scss";
</style>
